import { createFileRoute, Outlet } from "@tanstack/react-router";

import { guardModuleRoute } from "@/lib/module-guard";

export const Route = createFileRoute("/workshop")({
  beforeLoad: ({ location }) => guardModuleRoute(location.pathname),
  head: () => ({ meta: [{ title: "Workshop · AVS Gold ERP" }] }),
  component: () => <Outlet />,
});
